'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCol = exports.TableRow = exports.TableHeader = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  font-size: .9rem;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  font-size: .9rem;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  background-color: ', ';\n  font-weight: 700;\n  border-bottom: 1px solid ', ';\n'], ['\n  display: flex;\n  background-color: ', ';\n  font-weight: 700;\n  border-bottom: 1px solid ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  background-color: ', ';\n'], ['\n  display: flex;\n  background-color: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  flex-grow: ', ';\n  flex-basis: 0;\n  margin: 2px 8px 2px 4px;\n'], ['\n  flex-grow: ', ';\n  flex-basis: 0;\n  margin: 2px 8px 2px 4px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Table = _styledComponents2.default.div(_templateObject);

var TableHeader = exports.TableHeader = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.theme.bahTableHeaderColor;
}, function (props) {
  return props.theme.bahTableHeaderBorderColor;
});

var TableRow = exports.TableRow = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.theme.bahTableRowColor;
});

var TableCol = exports.TableCol = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.flexGrow || 1;
});

exports.default = Table;


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/Table.js
// module id = 109
// module chunks = 0